import { createSelector } from 'reselect';
import { getIsInitialActivitySetPollLoading } from 'lib/selectors/getIsInitialActivitySetPollLoading';
import { getPostLaborUpdatesOnNats } from 'lib/selectors/getPostLaborUpdatesOnNats';

const getIsLoadingJobRunASWrapper = createSelector(
  [getIsInitialActivitySetPollLoading, getPostLaborUpdatesOnNats],
  (isInitialActivitySetPollLoading, natsFlowEnabled) => {
    // In NATS mode, we don't wait for activity set loading
    if (natsFlowEnabled) {
      return false;
    }
    return isInitialActivitySetPollLoading;
  }
);

export { getIsLoadingJobRunASWrapper };
